import { useDeactivateUserModal } from '@views/pages/Admin/User/UserItem/hooks';
import { CustomModal } from '@components';
import { FC } from 'react';
import { t } from 'i18next';
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface DeactivateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: (id: string) => void;
  userId: string;
}

export const DeactivateUserModal: FC<DeactivateUserModalProps> = ({
  isOpen,
  onClose,
  userId,
  action,
}) => {
  const { userOptions, selectedUser, handleSelectUser } =
    useDeactivateUserModal(userId);

  return (
    <CustomModal
      onClose={onClose}
      isOpen={isOpen}
      title={t('adminPanel.users.deactivateModal.title')}
    >
      <Typography variant='body1'>
        {t('adminPanel.users.deactivateModal.message1')}
      </Typography>
      <Typography variant='body1' sx={{ my: 2 }}>
        {t('adminPanel.users.deactivateModal.message2')}
      </Typography>
      <Autocomplete
        autoComplete
        value={selectedUser}
        onChange={(e, value) => handleSelectUser(value)}
        options={userOptions}
        renderInput={params => (
          <TextField
            {...params}
            label={t('adminPanel.users.deactivateModal.assignTo')}
            fullWidth
            slotProps={{
              ...params.slotProps,
              input: {
                ...params.slotProps.input,
                startAdornment: (
                  <InputAdornment sx={{ mr: 0 }} position='start'>
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <Box
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'row',
                      },
                    }}
                  >
                    {params.slotProps.input?.endAdornment}
                  </Box>
                ),
              },
            }}
          />
        )}
      />
      <Box sx={{ display: 'flex', mt: 2, justifyContent: 'flex-end', mb: 3 }}>
        <Button onClick={onClose}>{t('general.cancel')}</Button>
        <Button
          onClick={() => action(selectedUser?.value || '')}
          variant='contained'
          color='secondary'
          sx={{ color: theme => theme.palette.common.white }}
        >
          {t('adminPanel.users.deactivateModal.deactivate')}
        </Button>
      </Box>
    </CustomModal>
  );
};
